import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-04-08'
        tag='Facebook Marketplace'
        title='The Seller Guide to Using Facebook Marketplace Ads'
      >
        <p>
          Facebook Marketplace is a page on the platform where users can search for, purchase, and sell products. Users
          can easily look through postings, search for items for sale in their region, and look for items that can be
          shipped to them. And the good thing is that it's not just limited to individuals who can use Marketplace to
          post products for sale. Companies can also use it to display store products, home rentals, autos, and event
          tickets.
        </p>
        <p>
          So many people and businesses are utilizing ads on the Facebook marketplace to get their products out for
          potential buyers to see. However, since we're talking about Facebook here, all Marketplace listings must
          adhere to their Commerce Policies (which outline what you can sell on Facebook) and the Community Standards
          (such as images and descriptions). This article will talk about how you can use Facebook marketplace ads to
          get your business noticed and convert more leads to sales.
        </p>

        <h3>What are Facebook Ads in the marketplace?</h3>
        <p>
          These are paid advertisements that display in between regular product listings on Marketplace (mobile only),
          allowing businesses to reach out to more consumers who are already scrolling and shopping with the intent to
          buy. While Facebook marketplace ads appear alongside other comparable products, they are distinguished by
          their greater size and the label titled "Sponsored."
        </p>
        <p>
          Like all other ad forms, the Facebook marketplace ads can be found in the Ads Manager. Here you can design and
          develop your own ad set, budget and choose a placement for your ads. The Automatic Placements setting on
          Facebook is recommended for advertising to display across several placement options such as News Feed,
          Instagram, Messenger, Audience Network, and Marketplace.
        </p>
        <p>
          And take note that because it is currently not possible for ads to only appear in Marketplace, they also
          appear as News Feed ads.
        </p>

        <h3>Benefits of Facebook Ads in the marketplace</h3>
        <p>
          As a seller, one of the main benefits of running ads on the Facebook marketplace is not just to attract
          potential buyers but also the following:
        </p>
        <ol>
          <li>
            <h4>Be visible to people where they're already buying.</h4>
            <p>
              While Facebook offers a variety of ad placement possibilities, what sets the marketplace apart is that
              most users who browse or search here have already made a purchase decision. They're actively shopping for
              items to buy, so when they see it alongside other relevant products and services, they're more likely to
              click on an ad and buy the advertised product.
            </p>
          </li>
          <li>
            <h4>Make personal contacts.</h4>
            <p>
              Because Facebook is essentially a social network, running ads on the marketplace still focuses on
              establishing personal connections with a specific demographic. So when someone wants to buy something on
              the Facebook marketplace, they usually do so through Messenger or by going to a post-click page. Messenger
              transactions keep users on the Facebook app and allow vendors to interact with potential buyers.
            </p>
          </li>
          <li>
            <h4>Automated ad placements will help you scale your business.</h4>
            <p>
              You can effortlessly grow your ads across Facebook using the same creative, targeting options, and
              optimization techniques. When creating a Facebook ad campaign, choose Automatic Placements to allow the ad
              to show throughout Facebook News Feed, Facebook Marketplace, Facebook Messenger, the Audience Network, and
              Instagram
            </p>
          </li>
        </ol>

        <h3>How it works: Creating an Ad. </h3>
        <ol>
          <li>
            {' '}
            From Ads Manager, select an ad objective:
            <ul>
              <li>Brand recognition</li>
              <li>Reach</li>
              <li>Traffic</li>
              <li>Views of the video</li>
              <li>Lead generation</li>
              <li>Messages</li>
              <li>Conversions</li>
              <li>Sales of catalogs</li>
              <li>Store traffic</li>
            </ul>
          </li>
          <li> Select a Destination</li>
          <li> Select an audience and define your targeting</li>
          <li>
            {' '}
            Select "Automatic Placements" or "Edit Placements" (Automatic Placements is suggested; if you pick Edit
            Placements, keep in mind that your campaign must still contain News Feed because Marketplace isn't a single
            ad placement).
          </li>
          <li> Set a budget and a schedule.</li>
          <li> Choose your ad's creative format and follow the ad specifications.</li>
        </ol>

        <h3>How to choose the right objective</h3>
        <p>
          Consider your business objectives before creating an ad. To choose the correct target, you must first know
          what you want to achieve and what you want consumers to do when they see your ad. You can, for example, design
          ads to urge people to visit your website if you want to show it to those who are interested in your business.
          The three major categories, or goals, into which your objectives may fall are listed below.
        </p>
        <ul>
          <li>
            Awareness: Objectives that promote interest in your product or service by telling consumers what makes your
            company valuable is one way to raise brand awareness. Jasper's Market, for example, is planning to build a
            small regional supermarket chain. Using the Brand Awareness goal as a starting point
          </li>
          <li>
            Consideration: Encourage consumers to think about your company and look for additional information. Jasper's
            Market, for example, has a website that describes its narrative and showcases some of its distinctive
            products. They can design a campaign using the traffic objective to encourage visitors to visit their site
            to learn more.
          </li>
          <li>
            Conversions: This goal motivates people interested in your company to buy or utilize your product or
            service. Jasper's Market, for example, has a few more locations. They can design a campaign using the Store
            traffic target to urge potential customers to visit their nearest store.
          </li>
        </ul>

        <h3>Ads review process</h3>
        <p>
          Facebook always checks your ads to ensure that they aren't violating their advertising policies before running
          on Facebook or Instagram. This occurs before ads begin to run automatically, and you can check the status of
          your ad in the Ads Manager's Delivery column.
        </p>
        <p>
          The ad review process mostly depends on automated technologies to cater to millions of users worldwide. Human
          reviewers are used to developing and training their automatic systems and manually examining some ads in
          certain circumstances.
        </p>
        <p>
          This evaluation process takes 24 hours and may include the ad's components, such as graphics, video, text,
          targeting information, and the ad's overall message.
        </p>

        <h3>What to do if the Ad is rejected</h3>
        <p>
          When an ad is rejected, Facebook will send you an email notification (if you've enabled alerts) and a link to
          Account Quality, where you can learn the reason it is denied. This may be useful in determining whether or not
          you wish to:
        </p>
        <p>
          To comply with Facebook's policies and make changes to your ad or create a new one. If you believe it was
          denied incorrectly, you can seek another review.
        </p>

        <h3>How to edit using Ads Manager</h3>
        <p>
          You can change your ad's name, identity, and ad creative, which includes the headline, text, image, and call
          to action, at the ad level. Facebook checks your ads based on their advertising policies before they run. This
          occurs before ads begin to run automatically, and you can check the status of your ad in the Ads Manager's
          Delivery column.
        </p>
        <p>To make changes to your ad, follow these steps:</p>
        <ol>
          <li>Go to the Ads Manager page.</li>
          <li>Select Ads.</li>
          <li>Select the checkboxes of the edits you want to make</li>
          <li>Choose Edit.</li>
          <li>To change the name of your ad, delete the old one and put a new one in the text box.</li>
          <li>
            To change your Page, choose a different Page from the options. (Take note that in a campaign where Reach is
            the goal, you can't change the Page for an ad. Instead, duplicate the ad set to which the ad belongs, modify
            the Page for both the ad set and the ad, and then publish)
          </li>
          <li>
            To edit your image or video, go to the Ad Creative area, select Edit, and then Change Media. Select Next
            after selecting a different image or movie. Then select Done to save your new material.
          </li>
          <li>
            If you want to change a picture or video for a single placement, click to view all placements in that group,
            then choose the one you want to edit.
          </li>
          <li>Select Publish to publish the changes and Close to save but publish later.</li>
        </ol>

        <p>
          Aside from running ads on the Facebook marketplace, one of the most effective ways for generating sales as a
          seller is to use automation tools to enhance your store. Optimize as many channels as you can to get your
          business more leads and convert sales with OneShop, an innovative automation tool that functions as a virtual
          assistant.{' '}
        </p>
        <p>
          OneShop can help you get a competitive advantage and enhance sales by increasing conversions by allowing you
          to sell across several platforms. It can cross-list things on many online marketplaces, freeing up time for
          sellers like you to focus on more important areas of your business rather than manually updating listings
          across platforms.{' '}
        </p>
        <p>Try it out for yourself with a free 7-day trial.</p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
